import React, { useEffect, useState } from "react";
import { GetFormPrice } from "../../../../../server/sharedScripts/getFormPrice.js";
import ComponentDisplay from "./ComponentDisplay.js";
export default function FlowDisplay(props) {
    var _a;
    const { components, inputState, onChange } = props;
    return (React.createElement("div", null, (_a = components === null || components === void 0 ? void 0 : components.filter((component) => component === null || component === void 0 ? void 0 : component.id)) === null || _a === void 0 ? void 0 : _a.map((component, index) => (React.createElement(ComponentDisplay, { component: component, componentsList: props.componentsList, key: component.id, form: props.inputState, isOutlined: component.id === props.outlinedComponent, onChange: (formState) => onChange({ ...inputState, ...formState }) })))));
}
FlowDisplay.useForm = (priceWithoutForm, components, inputFormResults) => {
    const [form, setForm] = useState();
    const [price, setPrice] = useState(0);
    useEffect(() => {
        const allFormsUpToDateresult = { ...inputFormResults, ...form };
        setPrice(GetFormPrice(allFormsUpToDateresult, components));
    }, [form]);
    return [form, setForm, priceWithoutForm + price];
};
